export default __webpack_public_path__ + "static/media/DP.d506a930.png";